export enum AlertType {
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  SUCCESS = 'success',
}

export interface Alert {
  type: AlertType;
  message: string;
}

export interface AppState {
  alert: Alert | null;
  isLoading: boolean;
  isMobile: boolean;
  isFileExplorerOpen: boolean;
}
